am4core.ready(function() {

	if ($('.datavis').length === 0) return;

	const emoteNames = ['happy', 'surprised', 'confused', 'disgusted', 'sad', 'angry', 'fear', 'calm'];
	const emoteObj = {'calm': 0, 'sad': 0, 'angry': 0, 'confused': 0, 'happy': 0, 'surprised': 0, 'fear': 0, 'disgusted': 0};
	const emoteDisplayNames = {'calm': 'Calm', 'sad': 'Sadness', 'angry': 'Anger', 'confused': 'Confusion', 'happy': 'Happiness', 'surprised': 'Surprise', 'fear': 'Fear', 'disgusted': 'Disgust'};

	const $tooltip = $('.tooltip');
	const $sliders = $('.slider');

	let tooltipVisible = false;

	const overallData = JSON.parse(window.dataVisOverall);
	const frameData = JSON.parse(window.dataVisFrames).map(frame => {
		// convert back to numbers
		emoteNames.forEach(emote => frame[emote] = parseFloat(frame[emote]))
		return frame;
	});

	renderEmoteGraph(overallData);
	setupSliders();

	function renderEmoteGraph(data) {
		const chart = am4core.create($('.emote-graph__graph')[0], am4charts.RadarChart);
		const chartData = emoteNames.map(name => ({emotion: emoteDisplayNames[name]}));
		chart.data = chartData;

		const data1 = emoteNames.map(name => ({
			emotion: emoteDisplayNames[name], 
			value: parseFloat(data[name])
		}));

		const seriesData = [
			{name: 'Video A', fill: '#27C1BB', data: data1, series: null},
		];

		const categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
		categoryAxis.dataFields.category = 'emotion';

		const valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
		valueAxis.min = 0;
		valueAxis.max = 100;

		seriesData.forEach(set => {
			const series = chart.series.push(new am4charts.RadarSeries());

			series.dataFields.valueY = 'value';
			series.dataFields.categoryX = 'emotion';
			series.name = set.name;
			series.strokeWidth = 3;
			series.fillOpacity = 0.3;
			series.fill = set.fill;
			series.stroke = set.fill;
			series.data = set.data;

			set.series = series;

			const bullet = series.bullets.push(new am4charts.CircleBullet());
			
			bullet.circle.strokeWidth = 2;
			bullet.circle.radius = 11;
			bullet.circle.fill = '#ffffff';
			bullet.fillOpacity = 0;
			bullet.circle.stroke = '#ffffff';
			bullet.strokeOpacity = 0;

			const hoverState = bullet.states.create("hover");
			hoverState.properties.fillOpacity = .6;
			hoverState.properties.strokeOpacity = 1;

			bullet.circle.events.on('over', event => {
				const index = event.target.dataItem.index;
				const emotion = data1[index].emotion;
				const val1 = data1[index].value.toFixed(1);
				updateTooltipContent(emotion, val1);
				showTooltip();
			});
			bullet.circle.events.on('out', hideTooltip);
		});

		$('.emote-graph__graph').on('mousemove', updateTooltipPosition);
	}

	function showTooltip() {
		if (tooltipVisible) return;
		$tooltip.addClass('show');
		tooltipVisible = true;
	}
	
	function hideTooltip() {
		$tooltip.removeClass('show');
		tooltipVisible = false;
	}
	
	function updateTooltipPosition(event) {
		if (!tooltipVisible) return;
		$tooltip.css({left: event.clientX + 'px', top: event.clientY + 'px'});
	}

	function updateTooltipContent(title, val1) {
		$('.tooltip__title').html(title);
		$('.tooltip__value').html(val1);
	}

	function setupSliders() {
		$sliders.each((index, el) => {
			const $slider = $(el);
			const $prevArrow = $slider.find('.slider__arrow.prev');
			const $nextArrow = $slider.find('.slider__arrow.next');

			$slider.flickity({
				wrapAround: false,
				imagesLoaded: true,
				cellSelector: '.slider__frame',
				cellAlign: 'center',
				prevNextButtons: false,
				pageDots: false,
				on: {
					change: cellIndex => {
						showFrameData(frameData[parseInt(cellIndex)]);
					},
					staticClick: (event, pointer, cellEl, cellIndex) => {
						$slider.flickity('select', cellIndex);
					}
				}
			});

			$prevArrow.on('click', () => $slider.flickity('previous'));
			$nextArrow.on('click', () => $slider.flickity('next'));
		});

		showFrameData(frameData[0]);
	}

	function showFrameData(frame) {
		emoteNames.forEach(name => {
			let val = frame[name];
			let level = 1;
			if (val >= 80) {
				level = 5;
			} else if (val >= 60) {
				level = 4;
			} else if (val >= 40) {
				level = 3;
			} else if (val >= 20) {
				level = 2;
			}
			$(`.frame-data__datum[data-emote="${name}"] .frame-data__value`).html(val.toFixed(1))
			$(`.frame-data__datum[data-emote="${name}"] .frame-data__bar`)
				.css('width', val + '%')
				.attr('data-level', level);
		});
	}

});